import { SelectModule } from '../select/select.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddMultiRiskFrameworkModalComponent } from './add-multi-risk-framework-modal.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { FormsModule } from '@angular/forms';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CygovButtonModule } from '../cygov-button/cygov-button.module';
import { FileUploadModule } from 'ng2-file-upload';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { UsernameIconModule } from '../username-icon/username-icon.module';
import { DatepickerFeatureModule } from 'app/board/board-wizard/report-duration/datepicker-feature/datepicker-feature.module';
import { AssessmentDurationCalendarModule } from '../assessment-duration-calendar/assessment-duration-calendar.module.ts';
import { SkeletonModule } from 'app/shared/skeleton/skeleton.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    FormsModule,
    SelectModule,
    NgbModule,
    CygovButtonModule,
    FileUploadModule,
    CheckboxModule,
    UsernameIconModule,
    NgbModule,
    DatepickerFeatureModule,
    NgbTooltipModule,
    AssessmentDurationCalendarModule,
    SkeletonModule,
  ],
  declarations: [AddMultiRiskFrameworkModalComponent],
  exports: [AddMultiRiskFrameworkModalComponent],
})
export class AddMultiRiskFrameworkModalModule {}
